module.exports = __webpack_public_path__ + "static/media/glass-citrus.aaa264b2.svg";